import { render, staticRenderFns } from "./NewLightDarkSwitch.vue?vue&type=template&id=4e568010&scoped=true&"
import script from "./NewLightDarkSwitch.vue?vue&type=script&lang=ts&"
export * from "./NewLightDarkSwitch.vue?vue&type=script&lang=ts&"
import style0 from "./NewLightDarkSwitch.vue?vue&type=style&index=0&id=4e568010&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e568010",
  null
  
)

export default component.exports